const DRAFT_STATUS = 'draft';
const SCHEDULED_STATUS = 'scheduled';

const useBatchStatus = (status, draftResponse, scheduledResponse) => {
  switch (status) {
    case DRAFT_STATUS:
      return draftResponse;
    case SCHEDULED_STATUS:
      return scheduledResponse;
    default:
      return null;
  }
};

export default useBatchStatus;
